import React, { ReactNode, useState } from "react"

import ClickAwayListener from "@material-ui/core/ClickAwayListener"
import Tooltip from "@material-ui/core/Tooltip"
import { Zoom } from "@material-ui/core"
import clsx from "clsx"
import Question from "../images/Question"
import question_icon from "../../../images/icons/icon_questionV2.svg"
import close_icon from "../../../images/icons/icon_closeV2.svg"

import * as styles from "./checkboxBlock.module.scss"
import { DLClickEventExtended } from "../../../helpers/WatcherDL/DLEvents"

interface IProps {
  checkboxActive: boolean
  onChangeCheckbox: () => void
  variantStyles?: string
  textTooltip?: ReactNode
}
const textBeforeTooltip = "С подпиской «Халва.Десятка»"

export const CheckboxBlock = ({
  checkboxActive,
  onChangeCheckbox,
  variantStyles,
  textTooltip,
}: IProps) => {
  const [openTooltip, setOpenTooltip] = useState(false)

  const handleTooltipClose = () => {
    setOpenTooltip(false)
  }

  const handleTooltipOpen = () => {
    DLClickEventExtended({
      name: "Tooltip",
      eventCategory: "click_tooltip",
      eventAction: textBeforeTooltip,
      placement: "calculator",
    })
    setOpenTooltip(true)
  }

  return (
    <div className={clsx(styles.checkboxBlock, variantStyles && styles[variantStyles])}>
      <label htmlFor="checkbox" className={styles.checkbox}>
        <input onChange={onChangeCheckbox} id="checkbox" type="checkbox" checked={checkboxActive} />
        <span className={clsx(styles.slider, styles.round)} />
      </label>
      <p className={styles.text}>{textBeforeTooltip}</p>
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <Tooltip
          classes={{
            tooltip: clsx(styles.tooltip, variantStyles && styles[variantStyles]),
          }}
          PopperProps={{
            disablePortal: false,
          }}
          onClose={handleTooltipOpen}
          open={openTooltip}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={
            textTooltip ? (
              <>
                <div className={styles.hintText}>{textTooltip}</div>
                <div
                  className={styles.hintIconClose}
                  onClick={handleTooltipClose}
                  aria-hidden="true"
                >
                  <img src={close_icon} alt="close" />
                </div>
              </>
            ) : (
              <>
                <img src={question_icon} alt="question" className={styles.hintIconQuestion} />
                <div className={styles.hintText}>
                  Подписка «Халва.Десятка» дает дополнительные преимущества вашей карте. Увеличенная
                  рассрочка* от 10 месяцев, повышенный кэшбэк до 10%. Первый месяц подписки – 0
                  рублей, далее – 399 рублей в мес. или 3799 руб. в год (скидка – 20%).
                </div>
                <div
                  className={styles.hintIconClose}
                  onClick={handleTooltipClose}
                  aria-hidden="true"
                >
                  <img src={close_icon} alt="close" />
                </div>
              </>
            )
          }
          TransitionComponent={Zoom}
        >
          <div className={styles.tooltipIcon} onClick={handleTooltipOpen} aria-hidden="true">
            <Question />
          </div>
        </Tooltip>
      </ClickAwayListener>
    </div>
  )
}
